// ChatBotWidget.js
import React, { useState } from "react";
import { FaCommentDots, FaTimes } from "react-icons/fa"; // Icons for open/close button and chat icon

const ChatBotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasNewMessage, setHasNewMessage] = useState(true); // To show a notification badge

  const toggleChat = () => {
    setIsOpen(!isOpen);
    setHasNewMessage(false); // Clear the notification when opened
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end">
      {/* Chat Bubble Button */}
      <button
        onClick={toggleChat}
        className="relative p-3 bg-yellow-500 text-gray-900 font-semibold rounded-full shadow-lg flex items-center hover:opacity-90 transition"
      >
        {isOpen ? (
          <FaTimes size={20} />
        ) : (
          <>
            <FaCommentDots size={20} />
            <span className="ml-2">Quick Question? We are here!</span>
            {hasNewMessage && (
              <span className="absolute top-0 right-0 w-3 h-3 bg-red-600 rounded-full"></span>
            )}
          </>
        )}
      </button>

      {/* Chat Box */}
      {isOpen && (
        <div className="mt-2 w-72 bg-white p-4 rounded-lg shadow-lg border border-gray-200">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-lg font-semibold text-gray-900">Online</h3>
            <span className="text-xs text-green-500 font-bold">• Online</span>
          </div>
          <p className="text-gray-700 mb-4">
            How can we assist you? Feel free to ask any questions!
          </p>
          <button
            onClick={toggleChat}
            className="p-2 bg-blue-600 text-white rounded-md w-full text-center font-semibold hover:bg-blue-700 transition"
          >
            Start Chat
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatBotWidget;
